/* eslint-disable react/jsx-props-no-spreading */
import NiceModal, { antdModalV5, useModal } from '@ebay/nice-modal-react';
import { Flex, Button } from 'antd';
import WARNING_ICON from 'Assets/icons/ic_warning.svg';
import Text from 'Components/Text';

import Modal from './Modal';
import styles from './WarningModal.less';

interface ICancelErrorModal {
  title?: string;
  message?: string;
  closeText?: string;
}

const WarningModal = NiceModal.create<ICancelErrorModal>(({ title, message, closeText }) => {
  const modal = useModal();

  return (
    <Modal {...antdModalV5(modal)} width={500}>
      <Flex vertical align="center" gap={40}>
        <img src={WARNING_ICON} alt="warning icon" className={styles.warningIcon} />
        <Flex vertical align="center" gap={16}>
          {title && <Text className={styles.title}>{title}</Text>}
          {!!message && <Text className={styles.message}>{message}</Text>}
        </Flex>
        <Button onClick={() => modal.hide()} type="default">
          {closeText ?? 'Close'}
        </Button>
      </Flex>
    </Modal>
  );
});

export default WarningModal;
